import { Features, isFeatureEnabled } from '../../featureToggles/features';
import { BlockedByFeature } from '../../featureToggles/features/utils';
import { ColumnFields } from '../../utils/dataTable/data';
import { RootState } from '../rootReducer';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface InvoiceViewState {
  fields: ColumnFields;
}

export const initialState: InvoiceViewState = {
  fields: {}
};

export const selectInvoicesDashboardFields = (state: RootState): ColumnFields => state.adminDashboard.invoices.fields;

const invoiceViewSlice = createSlice({
  name: 'invoicesViewAdminDashboard',
  initialState,
  reducers: {
    setInvoiceDashboardFields: (state: InvoiceViewState, action: PayloadAction<ColumnFields>) => {
      if (!isFeatureEnabled(Features.PlgExternal)) {
        console.info(`setInvoiceDashboardFields. ${BlockedByFeature}`);
        return;
      }
      state.fields = action.payload;
    }
  }
});

export const actions = {
  ...invoiceViewSlice.actions
};
export const invoicesReducer = invoiceViewSlice.reducer;
